import { DistanceUnit } from '../../types/__generated__';

const UNIT_ABBREVIATION = {
  METRES: 'm',
  KILOMETRES: 'km',
  FEET: 'ft',
  YARDS: 'yd',
  MILES: 'mi',
};

type ExpandedDistanceUnits = Readonly<keyof typeof UNIT_ABBREVIATION>;

function assertNever(x: never): never {
  throw new Error('Unexpected object: ' + x);
}

export const formatLargeValues = (
  value: number,
  unit: DistanceUnit,
): {
  unit: ExpandedDistanceUnits;
  value: number;
  formatOptions?: Intl.NumberFormatOptions;
} => {
  if (unit === DistanceUnit.Metres) {
    return value >= 1000
      ? {
          unit: 'KILOMETRES',
          value: value / 1000,
          formatOptions: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
        }
      : {
          unit: 'METRES',
          value,
          formatOptions: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
        };
  }
  if (unit === DistanceUnit.Feet) {
    return {
      unit: 'MILES',
      value: value / 5280,
      formatOptions: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    };
  }
  return assertNever(unit);
};
